import React, { useEffect, useState } from 'react'
import {
  BadgeStatusEntrega,
  Btn,
  CustomCard,
  CustomCheckbox,
  CustomDataTableHeader,
  SectionTitle,
  CustomDropdown,
} from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useBaixarCanhotos, { BAIXAR_CANHOTOS_ACTIONS } from './BaixarCanhotosState'
import { verde, vermelho } from '../../../../../assets/js/colors'
import CustomModal from '../../../../../components/CustomModal/CustomModal'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'

function BaixarCanhotos({ ciclo, dispatch }) {
  const { state, actions } = useBaixarCanhotos(ciclo)
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const usuario = getUsuarioInfo()

  const EXIBICAO_ENTREGAS_OPCOES = [
    { name: 'Todas', value: 'ALL' },
    { name: 'Com canhoto', value: 'COM' },
    { name: 'Sem canhoto', value: 'SEM' },
  ]

  useEffect(() => {
    switch (state.loading) {
      case BAIXAR_CANHOTOS_ACTIONS.LOADING_DELIVERIES:
        dispatch(showLoadingBox('Carregando entregas', 'Aguarde...'))
        break
      case BAIXAR_CANHOTOS_ACTIONS.DOWNLOADING_CANHOTOS:
        dispatch(showLoadingBox('Baixando canhotos', 'Aguarde...'))
        break
      default:
        dispatch(hideLoadingBox())
        break
    }
  }, [state.loading])

  useEffect(() => {
    if (state.successMessage) {
      setShowDownloadModal(true)
      actions.resetMessages()
    }
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      actions.resetMessages()
    }
  }, [state.errorMessage, state.successMessage])

  const farolTemplate = rowData => {
    const color = rowData.tem_canhoto ? verde : vermelho
    return (
      <div
        style={{
          width: 20,
          height: 20,
          borderRadius: '50%',
          backgroundColor: color,
          margin: '0 auto',
        }}
      />
    )
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <SectionTitle title="Baixar Canhotos" />
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Total de Entregas"
          subTitle="Quantidade total de entregas"
          valueStyle={{ fontSize: '1.3rem', fontWeight: 600 }}
        >
          {state.totalDeliveries}
        </CustomCard>
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Entregas com Canhoto"
          subTitle="Quantidade de entregas com canhoto"
          valueStyle={{ color: verde, fontSize: '1.3rem', fontWeight: 600 }}
        >
          {state.totalComCanhoto}
        </CustomCard>
      </div>

      <div className="p-col-4">
        <CustomCard
          title="Entregas sem Canhoto"
          subTitle="Quantidade de entregas sem canhoto"
          valueStyle={{ color: vermelho, fontSize: '1.3rem', fontWeight: 600 }}
        >
          {state.totalSemCanhoto}
        </CustomCard>
      </div>

      <div className="p-col-2" style={{ display: 'flex', alignItems: 'center', paddingTop: 52 }}>
        <CustomCheckbox
          checked={state.selecionarTodos}
          onChange={() => actions.onSelecionarTodos()}
        >
          Selecionar Todos
        </CustomCheckbox>
      </div>

      <div className="p-col-3" style={{ paddingTop: 23 }}>
        <CustomDropdown
          label="Exibir Entregas:"
          optionLabel="name"
          value={state.exibirEntregas}
          options={EXIBICAO_ENTREGAS_OPCOES}
          onChange={actions.onExibirEntregasChange}
        />
      </div>

      <div className="p-col-3" style={{ paddingTop: 52 }}>
        <Btn
          onClick={() => actions.onExportarClick(state.deliveriesFiltered)}
          style={{ marginRight: 10 }}
        >
          Exportar
        </Btn>
        <Btn onClick={actions.onBaixarCanhotos}>Processar Canhotos</Btn>
      </div>

      <div className="p-col-12">
        <DataTable
          header={<CustomDataTableHeader onChange={actions.onFilterChange} />}
          value={state.deliveriesFiltered}
          emptyMessage="Não existem entregas associadas a este ciclo"
          rows={10}
          paginator
        >
          <Column
            field="selected"
            header=""
            style={tableCellCentered(50)}
            body={rowData => (
              <CustomCheckbox
                checked={rowData.selected}
                onChange={value => actions.onCheckBoxClicked(rowData, value)}
                disabled={!rowData.tem_canhoto}
              />
            )}
          />
          <Column field="identifier" header="Identificador" />
          <Column field="client_fantasia" header="Cliente" />
          <Column field="qteSKU" header="Qte SKUs" style={tableCellCentered()} />
          <Column field="district" header="Bairro" />
          <Column field="city_name" header="Cidade" />
          <Column
            field="status"
            header="Status"
            body={e => <BadgeStatusEntrega status={e.status} />}
            style={tableCellCentered(170)}
          />
          <Column
            field="tem_canhoto"
            header="Canhoto"
            style={tableCellCentered(80)}
            body={farolTemplate}
          />
        </DataTable>
      </div>
      <CustomModal
        header="Download de Canhotos"
        isVisible={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
        width={600}
      >
        <div style={{ padding: 20, textAlign: 'center' }}>
          <p style={{ fontSize: 16, marginBottom: 24 }}>
            O download já está sendo realizado!
            <br />O arquivo com todos os canhotos selecionados será enviado ao email{' '}
            <b>{usuario.email}</b> em até 5 minutos.
            <br />
            <br />
            Caso não tenha recebido o email na caixa de entrada, verifique a área de spam.
            <br />
            <br />
            Atenção! O arquivo ficará disponível para download somente por <b>24 horas</b>, após o
            envio do email.
          </p>
          <Btn onClick={() => setShowDownloadModal(false)}>OK</Btn>
        </div>
      </CustomModal>
    </div>
  )
}

export default connect()(BaixarCanhotos)
